import script from "./TariffsListView.vue?vue&type=script&setup=true&lang=js"
export * from "./TariffsListView.vue?vue&type=script&setup=true&lang=js"

import "./TariffsListView.vue?vue&type=style&index=0&id=6c35ecdc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c35ecdc"]])

export default __exports__